import { type FC, type RefObject } from 'react';

// @ts-expect-error - IconCheckBold doesn't have TypeScript definitions
import { IconCheckBold } from 'src/assets/icons/IconCheckBold';
import { ChevronIcon } from 'src/components/ChevronIcon';
// @ts-expect-error - ContextMenu doesn't have TypeScript definitions
import { ContextMenu } from 'src/components/ContextMenu';
import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
  // @ts-expect-error - CustomButton doesn't have TypeScript definitions
} from 'src/components/CustomButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { EDITOR_LABEL_MAP, EDITOR_TYPE, type EditorType } from 'src/data/project';
import { ROTATE_DIRECTION } from 'src/data/ui';
import { type Callback, type VoidFunction } from 'src/lib/types';

import styles from './styles.module.scss';

const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
};

interface Props {
  onChange: Callback<EditorType>;
  editorType: EditorType;
}

interface ButtonProps {
  open: boolean;
  ref: RefObject<HTMLButtonElement>;
  onClick: VoidFunction;
}

export const EditorTypeDropdown: FC<Props> = ({ onChange, editorType }) => {
  const setEditorType = (type: EditorType) => {
    onChange(type);
  };

  const alignLabel = (label: string) =>
    `Create with ${label.replace(' ', '-').toLowerCase()} editor`;

  const menuItems = (Object.values(EDITOR_TYPE) as EditorType[]).map((value) => ({
    id: value,
    label: alignLabel(EDITOR_LABEL_MAP[value]),
    name: EDITOR_LABEL_MAP[value],
    icon: <IconCheckBold className={editorType === value ? styles.iconCheck : styles.iconHidden} />,
    onClick: () => {
      setEditorType(value);
    },
  }));

  const activeItem = menuItems.find((item) => item.id === editorType);

  if (!activeItem) {
    return null;
  }

  return (
    <ContextMenu
      classes={{ menuRoot: styles.menuRoot }}
      renderButton={(props: ButtonProps) => (
        <CustomTooltip title={activeItem.label}>
          <CustomButton
            className={styles.root}
            variant={CUSTOM_BUTTON_VARIANT.text}
            size={CUSTOM_BUTTON_SIZE.smaller}
            endIcon={
              <ChevronIcon
                className={styles.iconChevron}
                direction={props.open ? ROTATE_DIRECTION.up : ROTATE_DIRECTION.down}
              />
            }
            {...props}
          >
            {menuItems.find((item) => item.id === editorType)?.name || 'Select Editor'}
          </CustomButton>
        </CustomTooltip>
      )}
      items={menuItems}
      menuProps={MENU_PROPS}
    />
  );
};
